import { Button, Card, Result } from 'antd';
import type { ErrorInfo, ReactNode } from 'react';
import { Component } from 'react';
import { CPQ_SHELL_BASE_PATH } from '../runtimePaths';

interface RootErrorBoundaryState {
  error: Error | null;
}

export class RootErrorBoundary extends Component<
  { children: ReactNode },
  RootErrorBoundaryState
> {
  state: RootErrorBoundaryState = { error: null };

  static getDerivedStateFromError(error: Error): RootErrorBoundaryState {
    return { error };
  }

  componentDidCatch(_error: Error, _info: ErrorInfo) {
    console.error('[Vite CPQ 壳] 页面渲染失败');
  }

  render() {
    if (!this.state.error) return this.props.children;

    return (
      <Card variant="borderless" style={{ margin: 24 }}>
        <Result
          status="error"
          title="CPQ 页面渲染失败"
          subTitle="请重新加载当前 CPQ 页面。"
          extra={[
            <Button
              key="reload"
              type="primary"
              onClick={() => window.location.reload()}
            >
              重新加载
            </Button>,
            <Button key="home" href={CPQ_SHELL_BASE_PATH}>
              返回 CPQ 首页
            </Button>,
          ]}
        />
      </Card>
    );
  }
}
